import { Pipe, PipeTransform } from '@angular/core';
import * as Sugar from 'sugar';

@Pipe({
  name: 'camelize',
})
export class CamelizePipe implements PipeTransform {

  transform(value: string, ...args) {
    let name = value.split(' ');
    name = name.filter( s => s ).map( s => Sugar.String.camelize(s));

    return name.join(' ');
  }

}



// WEBPACK FOOTER //
// ./src/pipes/camelize/camelize.ts